import { useEffect } from "react";
import { X } from "lucide-react";

function vimeoIdFrom(url) {
  if (!url) return null;
  const m = url.match(/vimeo\.com\/(\d+)/);
  return m ? m[1] : null;
}
function youtubeIdFrom(url) {
  if (!url) return null;
  const m =
    url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{6,})/);
  return m ? m[1] : null;
}

export const VideoModal = ({ open, url, title, onClose }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    const lenis = window.__lenis;
    lenis?.stop?.();
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
      lenis?.start?.();
    };
  }, [open, onClose]);

  if (!open) return null;

  const vid = vimeoIdFrom(url);
  const yid = !vid ? youtubeIdFrom(url) : null;
  const src = vid
    ? `https://player.vimeo.com/video/${vid}?autoplay=1&title=0&byline=0&portrait=0`
    : yid
    ? `https://www.youtube.com/embed/${yid}?autoplay=1&rel=0`
    : url;

  return (
    <div
      data-testid="video-modal"
      role="dialog"
      aria-modal="true"
      aria-label={title || "Video"}
      className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 md:p-12"
      onClick={onClose}
    >
      <button
        data-testid="video-modal-close"
        aria-label="Close video"
        onClick={onClose}
        className="absolute top-6 right-6 md:top-10 md:right-10 inline-flex items-center justify-center w-11 h-11 rounded-full border border-white/30 text-ink-primary hover:border-ember hover:text-ember transition-colors"
      >
        <X size={18} />
      </button>
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-5xl aspect-video bg-black border border-white/10 shadow-[0_30px_120px_-30px_rgba(244,162,97,0.25)]"
      >
        <iframe
          data-testid="video-modal-iframe"
          src={src}
          title={title || "Reel"}
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          className="w-full h-full"
        />
      </div>
      <div className="absolute bottom-6 left-0 right-0 text-center font-sans text-[10px] tracking-widest2 uppercase text-ink-secondary pointer-events-none">
        Press ESC or tap outside to close
      </div>
    </div>
  );
};
